import { useAuth } from 'react-oidc-context';

import { useToFetchPatientDosageDiaries } from '../hooks/useToFetchPatientDosageDiaries';
import { useToDownloadDosageDiaryPDF } from '../hooks/useToDownloadDosageDiaryPDF';
import LoadingButton from '../components/LoadingButton';
import { PdfPreview } from './DocPreviewer';

export function PatientDosageDiaryList() {
  const { user } = useAuth();
  const [dosageDiary] = useToFetchPatientDosageDiaries(user!.access_token);
  const {
    handleDosageDiaryDownloadByProfile,
    previewUrl,
    profileName,
    previewBlob,
    closePreview,
    activeButtonIndex,
  } = useToDownloadDosageDiaryPDF(user!.access_token);

  return (
    <>
      {!dosageDiary.length ? (
        <p className="font-semibold text-center overflow-hidden">
          No dosage diary documents to display
        </p>
      ) : (
        <div className="grid grid-cols-1 gap-3 md:grid-cols-3 md:gap-4 pb-16">
          {dosageDiary.map((diary, index) => (
            <div
              key={index}
              className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow"
            >
              <div className="px-4 py-5 sm:px-6">
                <h3 className="text-lg font-medium leading-6 text-gray-900">
                  {diary.profileName}
                </h3>
              </div>
              <div className="px-4 py-5 sm:p-6">
                <ul className="list-disc list-inside">
                  {diary.products.map((product, index) => (
                    <li key={index}>{product}</li>
                  ))}
                </ul>
              </div>
              <div className="flex justify-between px-4 py-4 sm:px-6">
                <LoadingButton
                  key={diary.dosageDiaryId}
                  className="!w-fit !text-sm !font-medium !m-2 !rounded-md !shadow-sm"
                  isLoading={activeButtonIndex === diary.dosageDiaryId}
                  buttonText={'View & Download'}
                  isDisabled={activeButtonIndex === diary.dosageDiaryId}
                  onClick={() => {
                    handleDosageDiaryDownloadByProfile(
                      diary.dosageDiaryId,
                      diary.profileName,
                    );
                  }}
                />
              </div>
            </div>
          ))}
          {previewBlob ? (
            <PdfPreview
              previewUrl={previewUrl}
              profileName={profileName}
              closePreview={closePreview}
              previewBlob={previewBlob}
            />
          ) : null}
        </div>
      )}
    </>
  );
}
